import React, { useEffect, useState } from "react"
import { View, StyleSheet, ScrollView } from "react-native"
import { Button } from "@Components/CustomButton/Button"
import { ContainerGlogal } from "@Components/ContainerGlogal"
import { InputGroup } from "@Components/Input/InputGroups"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { useRecoilState } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { UserService } from "@Services/User.service"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { areEqual, isStrongPassword } from "@Utils/utils"
import { PasswordValidatorContent } from "@Screens/Register/PasswordValidatorContent"

const defaultpasswords = {
    oldPassword: "",
    password: "",
    retypePassword: ""
}

export const PasswordChangeForm = ({ navigation }) => {
    const [loading, setLoading] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [passwords, setPasswords] = useState(defaultpasswords)
    const [user, setUser] = useRecoilState(userAtom)

    const canSubmit = () => {
        return !(
            passwords.oldPassword.length > 0 &&
            passwords.password.length > 7 &&
            passwords.retypePassword.length > 7
        )
    }

    const performPasswordChange = () => {
        setLoading(true)
        if (user?.id) {
            UserService.changePassword({
                userId: user.id,
                actualPassword: passwords.oldPassword,
                password: passwords.password,
                retypePassword: passwords.retypePassword
            })
                .then((response) => {
                    console.log(response?.data)
                    setLoading(false)
                    if (response.data?.success) {
                        ShowToast({
                            type: "success",
                            message: "Mot de passe modifié avec succès"
                        })
                        setPasswords(defaultpasswords)
                    } else {
                        ShowToast({ type: "error", message: "l'ancien mot de passe ne correspond pas" })
                    }
                })
                .catch((e) => {
                    setLoading(false)
                    ShowToast({
                        type: "error",
                        message: "Oops une erreur est survenue ."
                    })
                })
        } else {
            setLoading(false)
        }
    }

    // const invalidPassword = () => isStrongPassword(passwords.password)
    // &&
    // passwords.retypePassword.length > 0 &&
    // passwords.password !== passwords.retypePassword

    useEffect(() => {
        UserService.getUserData().then((response) => {
            const userData = response.data.data
            if (userData) {
                setUser(userData)
            }
        })
    }, [])

    const isNotValidPassword =
        isStrongPassword(passwords.password) &&
        isStrongPassword(passwords.retypePassword) &&
        areEqual(passwords.password, passwords.retypePassword)

    return (
        <ContainerGlogal style={{ paddingTop: 10 }}>
            <ScrollView keyboardShouldPersistTaps={"handled"} contentContainerStyle={{ paddingBottom: 50 }}>
                <View style={styles.container}>
                    <BreeSerifText
                        style={{ textAlign: "left", fontSize: 20, color: baseColors.green.primary, paddingTop: 10 }}
                    >
                        Modifier mon mot de passe.
                    </BreeSerifText>
                    <OpenSansText>Renseignez votre nouveau mot de passe .</OpenSansText>
                    <View style={{ marginTop: 30 }}>
                        <InputGroup
                            disabled={loading}
                            onChange={(text) => {
                                setPasswords((old) => ({ ...old, oldPassword: text }))
                            }}
                            valid={passwords.oldPassword.length > 0}
                            value={passwords.oldPassword}
                            type={"password"}
                            label={"Mot de passe actuel"}
                            placeholder={"Tapez votre ancien mot de passe"}
                        />
                        <InputGroup
                            disabled={loading}
                            onChange={(text) => {
                                setPasswords((old) => ({ ...old, password: text }))
                            }}
                            valid={passwords.password.length > 0}
                            value={passwords.password}
                            type={"password"}
                            validation_message={"min. 8 caractères"}
                            label={"Nouveau mot de passe"}
                            placeholder={"Minimum 8 caractères"}
                        />
                        <InputGroup
                            disabled={loading}
                            onChange={(text) => {
                                setPasswords((old) => ({ ...old, retypePassword: text }))
                            }}
                            valid={passwords.retypePassword.length > 0}
                            value={passwords.retypePassword}
                            type={"password"}
                            validation_message={"min. 8 caractères"}
                            label={"Confirmer le mot de passe"}
                            placeholder={"Minimum 8 caractères"}
                        />
                        {passwords?.password?.trim()?.length > 0 && !isNotValidPassword && <PasswordValidatorContent />}
                    </View>

                    <Button
                        loading={loading}
                        disabled={canSubmit() || loading || !isNotValidPassword}
                        onPress={() => {
                            performPasswordChange()
                        }}
                        text="sauvegarder"
                        width="80%"
                        height={45}
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />
                </View>
            </ScrollView>
        </ContainerGlogal>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 0,
        paddingHorizontal: 20,
        backgroundColor: "white",
        alignContent: "center"
    },
    text: {
        color: baseColors.black,
        textAlign: "justify",
        fontFamily: "BreeSerif",
        fontSize: 16
    }
})
